import { useListView } from '../../core/ListViewProvider'
import { AvaliacoesListGrouping } from './AvaliacoesListGrouping'
import { AvaliacoesListSearchComponent } from './AvaliacoesListSearchComponent'

export const AvaliacoesListHeader = () => {
  const { selected } = useListView()

  return (
    <div className='card-header border-0 pt-6'>
      <AvaliacoesListSearchComponent
        actions={selected.length > 0 ? <AvaliacoesListGrouping /> : undefined}
      />
    </div>
  )
}
